import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import ImageCropper from '../../common/ImageCropper/ImageCropper.js'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import Quill from 'quill'
import CheckPermission from '../../common/Permissions/CheckPermission.js'
import Button from '../../common/CustomComponents/Button.js'
import Select from 'react-select'
import GroupCheckbox from '../../common/GroupCheckbox/GroupCheckbox.js'

// Extend Quill to handle Enter differently
const Block = Quill.import('blots/block')
Block.tagName = 'DIV'
Quill.register(Block, true)

const modules = {
  clipboard: {
    matchVisual: false,
  },
}

const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
  'color',
  'background',
  'align',
]

class CruiseTripAdd extends React.Component {
  state = {
    status: 'active',
    destination_id: '',
    name_en: '',
    name_ar: '',
    desc_en: '',
    desc_ar: '',
    policy_en: '',
    policy_ar: '',
    refund_policy_en: '',
    refund_policy_ar: '',
    img_en: null,
    img_ar: null,
    isSaving: false,
    isData: false,
    Edit: false,

    meta_title_en: '',
    meta_title_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    h1_ar: '',
    h1_en: '',
    h2_ar: '',
    h2_en: '',

    destination_list: [],
    destination_data: null,
    cruises_list: [],
    cruises: [],
    no_of_nights: 0,
    departure_location_ar: '',
    arrival_location_ar: '',
  }

  async componentDidMount() {
    await this.getDestinationList()
    await this.getCruiseList()
    const { id } = this.props
    this.setState({ id }, () => {
      if (id) {
        this.getCruieTripDetails()
      }
    })
  }

  getCruiseList = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/get-all-cruises`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            cruises_list: res.data.data?.filter((item) => item.is_active),
          })
        }
      })
  }

  getDestinationList = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/get-all-destinations`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            destination_list: res.data.data
              ?.filter((item) => item.is_active)
              ?.map((item) => ({
                label: `${item.name_en} / ${item.name_ar}`,
                value: item.id,
              })),
          })
        }
      })
  }

  getCruieTripDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/get-cruise-trip-details/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const cruiseTripData = res.data.data
          this.setState({
            ...cruiseTripData,
            destination_data: this.state.destination_list?.find((item) => item.value === cruiseTripData.destination_id),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleDescriptionChangeEn = (value) => {
    this.setState({
      desc_en: value,
    })
  }

  handleDescriptionChangeAr = (value) => {
    this.setState({
      desc_ar: value,
    })
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({
      [imgKeyName]: e,
      Edit: false,
    })
    if (imgKeyName == 'img_ar') {
      this.setState({ imgAr: URL.createObjectURL(e) })
    } else {
      this.setState({ imgEn: URL.createObjectURL(e) })
    }
  }

  onSaveData = () => {
    const formData = new FormData()

    formData.append('name_en', this.state.name_en)
    formData.append('name_ar', this.state.name_ar)
    formData.append('desc_en', this.state.desc_en)
    formData.append('desc_ar', this.state.desc_ar)
    formData.append('policy_en', this.state.policy_en)
    formData.append('policy_ar', this.state.policy_ar)
    formData.append('refund_policy_en', this.state.refund_policy_en)
    formData.append('refund_policy_ar', this.state.refund_policy_ar)
    formData.append('display_amount', this.state.display_amount)
    formData.append('departure_location', this.state.departure_location)
    formData.append('arrival_location', this.state.arrival_location)
    formData.append('departure_location_ar', this.state.departure_location_ar)
    formData.append('arrival_location_ar', this.state.arrival_location_ar)
    formData.append('details_en', this.state.details_en)
    formData.append('details_ar', this.state.details_ar)
    formData.append('no_of_nights', this.state.no_of_nights)
    formData.append('meta_title_en', this.state.meta_title_en)
    formData.append('meta_title_ar', this.state.meta_title_ar)
    formData.append('meta_desc_en', this.state.meta_desc_en)
    formData.append('meta_desc_ar', this.state.meta_desc_ar)
    formData.append('meta_keywords_en', this.state.meta_keywords_en)
    formData.append('meta_keywords_ar', this.state.meta_keywords_ar)
    formData.append('h1_ar', this.state.h1_ar)
    formData.append('h1_en', this.state.h1_en)
    formData.append('h2_ar', this.state.h2_ar)
    formData.append('h2_en', this.state.h2_en)

    formData.append('cruises', this.state.cruises)
    formData.append('destination_id', this.state.destination_data?.value)

    this.setState({ isData: true })

    if (this.state.img_en?.type) {
      formData.append('img_en', this.state.img_en, 'your_original_filename.jpeg')
    }
    if (this.state.img_ar?.type) {
      formData.append('img_ar', this.state.img_ar, 'your_original_filename.jpeg')
    }

    if (this.props.id) {
      formData.append('id', this.props.id)

      axios
        .put(Constant.getAPI() + `/trips/update-cruise-trip`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Cruise Trip has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + `/trips/add-cruise-trip`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Cruise Trip has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  handleDestinationChange = (event) => {
    this.setState({ destination_data: event })
  }

  handleClear = () => {
    this.setState({ destination_data: null })
  }

  handleCruiseChange = (event) => {
    this.setState({ cruises: event })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_en"
                    id="name_en"
                    placeholder={`Name: English`}
                    onChange={this.handleChange}
                    value={this.state.name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_ar"
                    id="name_ar"
                    placeholder={`Name: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Departure Location</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="departure_location"
                    id="departure_location"
                    placeholder={`Departure Location`}
                    onChange={this.handleChange}
                    value={this.state.departure_location}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Arrival Location</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="arrival_location"
                    id="arrival_location"
                    placeholder={`Arrival Location`}
                    onChange={this.handleChange}
                    value={this.state.arrival_location}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Departure Location: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="departure_location_ar"
                    id="departure_location_ar"
                    placeholder={`Departure Location: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.departure_location_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Arrival Location: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="arrival_location_ar"
                    id="arrival_location_ar"
                    placeholder={`Arrival Location: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.arrival_location_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Display Amount</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="display_amount"
                    id="display_amount"
                    placeholder={`Display Amount`}
                    onChange={this.handleChange}
                    value={this.state.display_amount}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">No Of Nights</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="no_of_nights"
                    id="no_of_nights"
                    min={0}
                    placeholder={`No Of Nights`}
                    onChange={this.handleChange}
                    value={this.state.no_of_nights}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Select Destination</label>
                <div className="col-sm-9">
                  <Select
                    name="destination_data"
                    value={this.state.destination_data}
                    onChange={this.handleDestinationChange}
                    options={this.state.destination_list}
                    isMulti={false}
                    isSearchable={true}
                    isClearable
                    onClear={this.handleClear}
                    placeholder="Select Options"
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-12">
              <GroupCheckbox
                title={'Cruises'}
                list={this.state.cruises_list}
                displayKey={'name_en'}
                idKey={'id'}
                selected={this.state.cruises}
                onChange={(event) => this.handleCruiseChange(event)}
              ></GroupCheckbox>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Details: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="details_en"
                    id="details_en"
                    placeholder={`Details: English`}
                    maxLength={25}
                    onChange={this.handleChange}
                    value={this.state.details_en}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.details_en ? this.state.details_en.length + ' / 25' : 0 + ' / 25'}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Details: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="details_ar"
                    id="details_ar"
                    placeholder={`Details: Arabic`}
                    maxLength={25}
                    onChange={this.handleChange}
                    value={this.state.details_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.details_ar ? this.state.details_ar.length + ' / 25' : 0 + ' / 25'}
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="desc_en"
                    id="desc_en"
                    modules={modules}
                    formats={formats}
                    value={this.state.desc_en}
                    onChange={this.handleDescriptionChangeEn}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="desc_ar"
                    id="desc_ar"
                    modules={modules}
                    formats={formats}
                    value={this.state.desc_ar}
                    onChange={this.handleDescriptionChangeAr}
                  />
                </div>
              </div>
            </div>
            {/* <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Policy: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="policy_en"
                    id="policy_en"
                    value={this.state.policy_en}
                    onChange={(value) => {
                      this.setState({
                        policy_en: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Policy: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="policy_ar"
                    id="policy_ar"
                    value={this.state.policy_ar}
                    onChange={(value) => {
                      this.setState({
                        policy_ar: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div> */}
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Refund Policy: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="refund_policy_en"
                    id="refund_policy_en"
                    value={this.state.refund_policy_en}
                    onChange={(value) => {
                      this.setState({
                        refund_policy_en: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Refund Policy: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="refund_policy_ar"
                    id="refund_policy_ar"
                    value={this.state.refund_policy_ar}
                    onChange={(value) => {
                      this.setState({
                        refund_policy_ar: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Trip Image: English</div>
                <div className="col-sm-6">
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_en || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_en')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Trip Image: Arabic</div>
                <div className="col-sm-6">
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_ar || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_ar')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <CheckPermission permission={'manage-meta-tags'}>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              ></div>
              <h5 style={{ marginBottom: 23, marginLeft: 13, fontWeight: 'bold', fontSize: 18 }}>Meta Settings</h5>
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_en"
                      id="meta_title_en"
                      placeholder=""
                      onChange={this.handleChange}
                      value={this.state.meta_title_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_ar"
                      id="meta_title_ar"
                      placeholder=" "
                      onChange={this.handleChange}
                      value={this.state.meta_title_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Keywords: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_en"
                      id="meta_keywords_en"
                      placeholder=""
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Keywords: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_ar"
                      id="meta_keywords_ar"
                      placeholder=""
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_en"
                      id="meta_desc_en"
                      value={this.state.meta_desc_en}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_ar"
                      id="meta_desc_ar"
                      value={this.state.meta_desc_ar}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_en"
                      id="h1_en"
                      placeholder="H1: English"
                      onChange={this.handleChange}
                      value={this.state.h1_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_ar"
                      id="h1_ar"
                      placeholder="H1: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h1_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_en"
                      id="h2_en"
                      placeholder="H2: English"
                      onChange={this.handleChange}
                      value={this.state.h2_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_ar"
                      id="h2_ar"
                      placeholder="H2: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h2_ar}
                    />
                  </div>
                </div>
              </div>
            </CheckPermission>
          </div>
          <div className="row float-right p-3">
            <Button
              disabled={this.state.isData}
              onClick={this.onSaveData}
              startIcon={<i className="icofont icofont-save"></i>}
            >
              {this.state.isData ? 'Saving...!' : 'Save'}
            </Button>
            <Button
              to={`/cruise-trip`}
              variant="outlined"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default CruiseTripAdd
